/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from '../Modal';
import useForm from '../../hooks/useForm';
import Form from '../Form';
import { sendNewsLetter } from '../../apis/admin/newsletter';
import { toast } from '../../utils/toast';
import { cleanObj } from '../../utils/cleanObj';

const defaultForm = {
  email: "",
  footerType: "logo",
};

const TestMailSendModal = (props) => {
  const { open, setOpen, selectedItem, setSelectedItem, type = "YDS" } = props;
  const [fields] = useState([
    // {
    //   title: "푸터 타입",
    //   key: "footerType",
    //   type: "radio",
    //   required: true,
    //   options: {
    //     list: [{ label: "로고", value: "logo" }, { label: "텍스트", value: "text" }]
    //   }

    // },
    {
      title: "이메일",
      key: "email",
      type: "input",
      required: true,
      validators: ['email']
    }
  ]);

  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    setForm(defaultForm);
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };

  const _submit = (form) => {
    const params = {
      idx: selectedItem.idx,
      isTest: true,
      type,
      testMail: form.email,
      footerType: form.footerType,

    };
    cleanObj(params);
    sendNewsLetter(params).then(res => {
      toast.success("메일 전송요청이 완료되었습니다.");
      cancel();
    }).catch((err) => {
      console.error(err);
    });
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
      >
        <ModalHeader>
          {`뉴스레터 [${selectedItem?.title}] 테스트 메일 발송하기`}
        </ModalHeader>
        <Form
          fields={fields}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          onChange={handleOnChange}
          submitText={"테스트 메일 발송"}
          submit={handleSubmit}
        />
      </Modal>
    </>
  );
};

export default TestMailSendModal;